// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Sprint 63.37.0 (Stream J) — a form instance's status, as a reader reads it.
 *
 * The Vietnamese rehearsal found the instance page printing `completed`,
 * `finalized` and `draft` as stored, the forms dashboard printing them through
 * a key family that does not exist (`forms.filler.status_*`), three parent
 * pages each carrying their own label map with English fallbacks, and the
 * print export writing "Trạng thái: completed". Every one now reads the
 * platform's status vocabulary (`common_statuses`, which carries the embedded
 * statuses `finalized` and `superseded` since this sprint) through this one
 * rule; a status the vocabulary does not name reads as itself with its
 * underscores spaced, never as an empty cell.
 */
export function formInstanceStatusLabel(status, statuses) {
    if (typeof status !== 'string' || status.length === 0)
        return '—';
    const label = statuses[status];
    return typeof label === 'string' && label.length > 0 ? label : status.replace(/_/g, ' ');
}
//# sourceMappingURL=form-instance-status.js.map